import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import { StyledContainer, StyledFeature } from './PrivacyPolicyFeatures.styled';

const PrivacyPolicyFeatures: React.FC = () => {
  const { t } = useI18n('privacyPolicy');
  const features = [
    {
      image: getPublicPath('/images/privacyPolicy/feature01.svg'),
      title: t('policyFeatures.features.feature1.title'),
      text: t('policyFeatures.features.feature1.text')
    },
    {
      image: getPublicPath('/images/privacyPolicy/feature02.svg'),
      title: t('policyFeatures.features.feature2.title'),
      text: t('policyFeatures.features.feature2.text')
    },
    {
      image: getPublicPath('/images/privacyPolicy/feature03.svg'),
      title: t('policyFeatures.features.feature3.title'),
      text: t('policyFeatures.features.feature3.text')
    }
  ];
  return (
    <StyledContainer>
      {features.map((f, i) => (
        <StyledFeature key={i}>
          <img src={f.image} alt="" />
          <div>
            <Heading2 editorial>{f.title}</Heading2>
            <div dangerouslySetInnerHTML={{ __html: f.text }}></div>
          </div>
        </StyledFeature>
      ))}
    </StyledContainer>
  );
};

export default PrivacyPolicyFeatures;
